module.exports = __webpack_public_path__ + "static/media/rocket.3869eb51.png";